import dayjs from 'dayjs';

export const subtractDays = (date: Date, days: number): Date => {
  return dayjs(date).subtract(days, 'day').toDate();
}

export const getOfferEndDateTime = (offerStartDateTime?: string, offerEndTime?: string): string | undefined => {
  if (offerStartDateTime && offerEndTime) {
    const offerDate = offerStartDateTime.split('T')[0];
    const isSameDay = dayjs(offerStartDateTime).isBefore(
      dayjs(offerDate + 'T' + offerEndTime + 'Z'),
    );

    return (
      (isSameDay
        ? offerDate
        : dayjs(offerStartDateTime).add(1, 'day').format('YYYY-MM-DD')) +
      'T' +
      offerEndTime +
      'Z'
    );
  }
  return undefined;
};

export const getEventTimeZoneFromCoordinates = async (
  lat: number, lon: number, googleMapsApiKey: string) => {
  try {
    if (!googleMapsApiKey) {
      console.warn('Google Maps API key not available');
      return null;
    }

    const timestamp = Math.floor(Date.now() / 1000);
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lon}&timestamp=${timestamp}&key=${googleMapsApiKey}`
    );
    const data = await response.json();

    if (data.status === 'OK') {
      return {
        dstOffset: data.dstOffset,
        rawOffset: data.rawOffset,
        timeZoneId: data.timeZoneId,
        timeZoneName: data.timeZoneName,
      };
    }
    return null;
  } catch (error) {
    return null;
  }
}
